import { Input, OnInit, Component, EventEmitter, Output } from '@angular/core';
import { BehavioralThumbnailType } from '../../constants-types/BehavioralThumbnail.interface';
import { AssessmentType } from '../../constants-types/Enums';
import { AssessmentMethods } from '../../core-data-model/AssessmentMethods';
import { Job } from '../../core-data-model/Job.model';
import { JobAssessment } from '../../core-data-model/JobAssessment.model';
import { Person } from '../../core-data-model/Person.model';
import { SearchResult } from '../../core-data-model/SearchResult.model';
import { DateFormatUtility } from '../../core-utilities/DateFormat.utility';
import { TranslationService } from '../../translations';
import { AssessmentStatusTableCellProperties } from './AssessmentStatusTableCellProperties';

@Component({
    selector: 'behavioral-thumb',
    template: `
        @if (properties) {
            @if (properties.thumbnailConfig) {
                <div>
                    <assessment-thumbnail
                        [properties]="properties.thumbnailConfig"
                        [originalIdIncorrect]="originalIdIncorrect"
                    ></assessment-thumbnail>
                </div>
            } @else {
                @if (properties.reminderConfig) {
                    <assessment-reminder-v2
                        (dataChange)="dataChange.emit()"
                        [properties]="properties.reminderConfig"
                    ></assessment-reminder-v2>
                }
            }
        }
    `,
    standalone: false
})
export class BehavioralThumbnail implements OnInit {
    @Input()
    result: SearchResult | JobAssessment;
    @Input()
    originalIdIncorrect = false;

    // The following is a bad practice, but doing it for now. Hopefully
    // further refactoring will occur
    @Input()
    jobMode = false;

    @Output()
    dataChange = new EventEmitter();

    properties: AssessmentStatusTableCellProperties;

    constructor(
        private TR: TranslationService,
        private date: DateFormatUtility
    ) {}

    ngOnInit() {
        this.properties = this.jobMode
            ? this.getJobAssessmentBehavioralStatus(this.result)
            : this.getBehavioralAssessmentStatus(this.result);
    }

    private getBehavioralAssessmentStatus(
        result: SearchResult
    ): AssessmentStatusTableCellProperties {
        const id: string = result.id;

        const behavioralAssessmentStatus =
            {} as AssessmentStatusTableCellProperties;

        if (result instanceof Person) {
            const firstName = result.firstName;
            const lastName = result.lastName;
            // Case: Scored Behavioral Assessment => Display the Behavioral Chart
            if (result.hasAssessments() && result.hasBehavioralPattern()) {
                behavioralAssessmentStatus.thumbnailConfig = {
                    firstName,
                    lastName,
                    personOrJob: {
                        isPerson: result instanceof Person,
                        id
                    },
                    behavioralType: BehavioralThumbnailType.Person,
                    svgType: 'behavioral',
                    pattern: result.self,
                    assessmentId: result.originalAssessmentId
                };
                // Case: Assessment is Send and is Pending => Resend
                // Case: No Behavioral Assessment Sent => Send
            } else {
                behavioralAssessmentStatus.reminderConfig =
                    AssessmentMethods.getReminderConfig(
                        result.latestBehavioralAssessment,
                        AssessmentType.Behavioral,
                        result.id,
                        result.latestBehavioralAssessment
                            ? result.latestBehavioralAssessment.sentDate
                            : null,
                        this.TR,
                        this.date,
                        result.latestBehavioralAssessment
                            ? result.latestBehavioralAssessment.id
                            : undefined
                    );
            }
        } else if (result instanceof Job) {
            if (result.hasBehavioralJobTarget) {
                behavioralAssessmentStatus.thumbnailConfig = {
                    personOrJob: {
                        isPerson: result instanceof Person,
                        id
                    },
                    behavioralType: BehavioralThumbnailType.Job,
                    svgType: 'jobTarget',
                    jobPatternRanges: result.behavioralRanges
                };
            } else {
                behavioralAssessmentStatus.reminderConfig =
                    AssessmentMethods.getJobTargetReminderConfig(id);
            }
        }

        return behavioralAssessmentStatus;
    }
    getJobAssessmentBehavioralStatus(result: SearchResult | JobAssessment) {
        if (result instanceof JobAssessment) {
            const ja = result;
            if (ja.isPendingOrExpired()) {
                return null;
            }

            const behavioralAssessmentStatus =
                {} as AssessmentStatusTableCellProperties;

            behavioralAssessmentStatus.thumbnailConfig = {
                personOrJob: {
                    isPerson: false,
                    id: ja.id
                },
                firstName: ja.recipientName,
                lastName: '',
                behavioralType: BehavioralThumbnailType.Job,
                svgType: 'jobTarget',
                pattern: ja.behavioralPattern
            };
            return behavioralAssessmentStatus;
        } else if (result instanceof Person) {
            const behavioralAssessmentStatus =
                {} as AssessmentStatusTableCellProperties;

            behavioralAssessmentStatus.thumbnailConfig = {
                personOrJob: {
                    isPerson: true,
                    id: result.id
                },
                firstName: result.firstName,
                lastName: result.lastName,
                behavioralType: BehavioralThumbnailType.Person,
                svgType: 'behavioral',
                pattern: result.originalAssessment.pattern.self
            };
            return behavioralAssessmentStatus;
        }
    }
}
